<style lang="sass">
    @import ../../../common/styles/mixins
    @import ../../../common/styles/settings

    .paragraph-product-content-video

        &__background
            height: 100%
            background-size: cover
            min-height: 22rem
            width: 425px
            background-position: center
            +media("<=1150px")
                width: 100%
            +media("<=768px")
                background-size: 100% 21rem
                background-repeat: no-repeat
                width: 100%

    .paragraph-product-content

        iframe
            width: 100%
            +media("<=768px")
                height: 22rem

        &__right, &__left
            iframe
                width: 425px
                flex-grow: 1
                object-fit: cover
                object-position: center
                +media("<=1150px")
                    width: 100%

        &__center
            .paragraph-product-content-video
                &__background
                    margin-left: auto
                    margin-right: auto

            iframe
                flex-grow: 1
                object-fit: cover
                object-position: center
                height: 22rem
                display: block
                +media("<=560px")
                    min-width: auto
                    max-width: -webkit-fill-available

</style>


<script>

    import URI from 'urijs'

    export default {

        props: [ "url" ],

        mounted: function() {
            const tacDiv = this.$refs["tac-container"];
            tacDiv.setAttribute("videoID", this.youtubeVideoId);
        },

        computed: {
            youtubeVideoId: function() {
                let string = URI(this.url).search();
                let split = string.split("v=");
                return split[1];
            }
        }

    }

</script>
